<app-header></app-header>
<article [ngClass]="{'article-overRide':(user.role == 'SECURITY' || user.role == 'RECEIVER')}">
  <header>
    <div class="d-flex align-items-center">
      <a (click)="toggleLeftMenu()" id="menuBar" class="menu-bar">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="17.177" viewBox="0 0 20 17.177">
          <path id="Icon_material-menu" data-name="Icon material-menu"
                d="M4.5,26.177h20V23.315H4.5Zm0-7.157h20V16.157H4.5ZM4.5,9v2.863h20V9Z"
                transform="translate(-4.5 -9)" fill="#636363"/>
        </svg>
      </a>
      <a class="logo d-block d-sm-none">
        <img src="/assets/images/logo.png">
      </a>
      <!--<h1 [hidden]="user.role !== 'ROLE_USER'" class="d-none d-sm-block">{{g.page}}</h1>
      <h1 [hidden]="user.role !== 'ROLE_ADMIN'" class="d-none d-sm-block">{{g.page}}</h1>
      <h1 [hidden]="user.role !== 'ACCOUNT_OWNER'" class="d-none d-sm-block">{{g.page}}</h1>-->
    </div>
    <ul>
      <li *ngIf="user.userId != user.adminUserId && user.adminUserId != null && user.adminUserId != 0">
        Back to main dashboard
        <div class="custom-control custom-switch dashboard-switch ml-3" id="switchToAdmin">
          <input type="checkbox" class="custom-control-input" (click)="switchToAdmin()" checked id="customSwitch1">
          <label class="custom-control-label" for="customSwitch1"></label>
        </div>
      </li>
      <li style="border-left:none;" *ngIf="user.role === 'DEMO_ACCOUNT'">
        <label class="deskContent">Demo Account will be expired in <span>{{user.duration}} days</span></label>
      </li>
      <li style="border-left:none;" class="" *ngIf="user.role === 'DEMO_ACCOUNT' && user.loadedSampleData !== 'Y'">

        <button class="btn btn-orange deskContent" (click)="loadData()" style="height:37px; width: 100%;">Load Data
        </button>
      </li>
      <li style="border-left:none;" *ngIf="user.role !== 'SECURITY'">
        <!--
                <button type="submit" onclick="/support/summary.href=https://desk.zoho.in/portal/shiftsupplychainsolutions/" target="_blank" class="btn btn-cancel">Support</button>
        -->
        <a *ngIf="user.role === 'ACCOUNT_OWNER' || user.role === 'ROLE_USER' || user.role === 'AO_SELLER'" class="btn btn-cancel"
           routerLink="/admin/ticketList" style="height:37px; width: 100px;">Support</a>
      </li>
      <li style="border-left:none;padding: 1px;">
        <a *ngIf="user.role === 'ACCOUNT_OWNER'" class="" placement="bottom" ngbTooltip="Wallet" routerLink="/admin/credits">
          <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
               width="18pt" height="18pt" viewBox="0 0 512.000000 512.000000"
               preserveAspectRatio="xMidYMid meet">
            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
               fill="#ee7125" stroke="none">
              <path d="M2330 5110 c-494 -48 -950 -230 -1350 -538 -195 -150 -448 -432 -594
                  -662 -63 -99 -186 -351 -230 -471 -49 -134 -102 -340 -128 -499 -31 -195 -31
                  -565 0 -760 45 -276 116 -498 237 -745 132 -269 269 -460 489 -681 221 -220
                  412 -357 681 -489 247 -121 469 -192 745 -237 195 -31 565 -31 760 0 276 45
                  498 116 745 237 269 132 460 269 681 489 220 221 357 412 489 681 88 179 132
                  296 180 476 63 240 78 371 78 649 0 278 -15 409 -78 649 -48 180 -92 297 -180
                  476 -132 269 -269 460 -489 681 -221 220 -412 357 -681 489 -246 121 -474 193
                  -740 235 -147 23 -475 34 -615 20z m585 -339 c633 -106 1170 -457 1523 -995
                  170 -258 286 -563 339 -891 24 -153 24 -497 0 -650 -106 -651 -457 -1196
                  -1001 -1553 -258 -170 -563 -286 -891 -339 -153 -24 -497 -24 -650 0 -652 106
                  -1195 455 -1553 1001 -170 258 -286 563 -339 891 -24 153 -24 497 0 650 106
                  651 457 1196 1001 1553 298 196 666 322 1036 356 108 10 418 -4 535 -23z"/>
              <path d="M1695 3826 c-94 -41 -124 -168 -58 -247 49 -58 58 -59 455 -60 310 0
                  373 -3 429 -17 127 -33 249 -132 302 -244 l25 -53 -573 -5 c-560 -5 -574 -5
                  -601 -26 -53 -39 -69 -71 -69 -134 0 -63 16 -95 69 -134 27 -21 41 -21 601
                  -26 l573 -5 -25 -53 c-53 -112 -175 -211 -302 -244 -56 -14 -119 -17 -429 -17
                  -316 -1 -369 -3 -399 -17 -71 -34 -109 -122 -84 -195 8 -25 196 -219 683 -706
                  730 -729 692 -696 785 -678 49 9 109 69 118 118 18 92 37 68 -528 635 l-522
                  522 162 0 c178 0 267 13 382 56 227 84 422 302 481 537 l12 45 118 4 c128 3
                  149 11 194 72 29 39 29 133 0 172 -45 61 -66 69 -193 72 l-118 4 -17 60 c-17
                  60 -67 167 -105 223 l-21 30 189 5 c171 5 192 7 217 26 53 39 69 71 69 134 0
                  63 -16 95 -69 134 -27 21 -36 21 -874 23 -689 2 -853 0 -877 -11z"/>
            </g>
          </svg>

        </a>
      </li>
      <li class="btn-group" style="border-left:none;">
        <a class="dropdown-toggle" role="button" data-toggle="dropdown" data-display="static" aria-haspopup="true"
           aria-expanded="false">
          <svg height="25px" viewBox="0 0 512 512" width="25px" xmlns="http://www.w3.org/2000/svg">
            <path fill="#636363"
                  d="m437.019531 74.980469c-48.351562-48.351563-112.640625-74.980469-181.019531-74.980469-68.382812 0-132.667969 26.628906-181.019531 74.980469-48.351563 48.351562-74.980469 112.636719-74.980469 181.019531 0 68.378906 26.628906 132.667969 74.980469 181.019531 48.351562 48.351563 112.636719 74.980469 181.019531 74.980469 68.378906 0 132.667969-26.628906 181.019531-74.980469 48.351563-48.351562 74.980469-112.640625 74.980469-181.019531 0-68.382812-26.628906-132.667969-74.980469-181.019531zm-308.679687 367.40625c10.707031-61.648438 64.128906-107.121094 127.660156-107.121094 63.535156 0 116.953125 45.472656 127.660156 107.121094-36.347656 24.972656-80.324218 39.613281-127.660156 39.613281s-91.3125-14.640625-127.660156-39.613281zm46.261718-218.519531c0-44.886719 36.515626-81.398438 81.398438-81.398438s81.398438 36.515625 81.398438 81.398438c0 44.882812-36.515626 81.398437-81.398438 81.398437s-81.398438-36.515625-81.398438-81.398437zm235.042969 197.710937c-8.074219-28.699219-24.109375-54.738281-46.585937-75.078125-13.789063-12.480469-29.484375-22.328125-46.359375-29.269531 30.5-19.894531 50.703125-54.3125 50.703125-93.363281 0-61.425782-49.976563-111.398438-111.402344-111.398438s-111.398438 49.972656-111.398438 111.398438c0 39.050781 20.203126 73.46875 50.699219 93.363281-16.871093 6.941406-32.570312 16.785156-46.359375 29.265625-22.472656 20.339844-38.511718 46.378906-46.585937 75.078125-44.472657-41.300781-72.355469-100.238281-72.355469-165.574219 0-124.617188 101.382812-226 226-226s226 101.382812 226 226c0 65.339844-27.882812 124.277344-72.355469 165.578125zm0 0"/>
          </svg>
          <span class="ml-2">{{user.userName}}</span>
        </a>
        <div class="dropdown-menu dropdown-menu-right">
          <a (click)="logout()" id="logOut" class="dropdown-item">Logout</a>
          <hr *ngIf="user.role === 'DEMO_ACCOUNT'">
          <!--<a id="loadData" class="dropdown-item" (click)="loadData()" *ngIf="user.role === 'DEMO_ACCOUNT'">Load Sample Data</a>-->
          <a href="#" class="btn btn-orange MobileContent" style="height:37px; width: 100%;"
             *ngIf="user.role === 'DEMO_ACCOUNT'">Upgrade Account</a>
        </div>
      </li>
    </ul>
  </header>
  <div *ngIf="activate">
    <router-outlet></router-outlet>
  </div>
</article>
<app-footer></app-footer>
